import apiClient from './client';

// ─── Orte ────────────────────────────────────────────────────────────────────
//
// Die Auflösung von Ortstexten in Koordinaten läuft auf dem Server. Vorher tat
// es der Browser: bei jedem Aufruf der Karte neu, eine Anfrage je Ort, 1,1
// Sekunden Pause dazwischen, Zwischenspeicher nur für die Sitzung. Ein Baum
// mit 400 Orten brauchte damit über sieben Minuten – jedes Mal, in jedem
// Browser jedes Nutzers.

export type Ortsstand = 'zugeordnet' | 'offen' | 'nicht_gefunden' | 'von_hand' | 'ohne_karte';
export type Ortsverdacht = 'ok' | 'fremdes_land' | 'zu_grob' | 'unsicher';

export interface Ortseintrag {
  schluessel: string;
  rohtext: string;
  anzahl: number;
  stand: Ortsstand;
  lat: number | null;
  lon: number | null;
  /** Land laut Dienst, zwei Buchstaben. */
  landCode: string | null;
  /** Der Name, unter dem der Dienst den Ort führt – die Probe aufs Exempel. */
  anzeigename: string | null;
  verdacht: Ortsverdacht;
  grund: string | null;
}

export interface Kartenort {
  schluessel: string;
  rohtext: string;
  lat: number;
  lon: number;
  anzeigename: string | null;
  verdacht: Ortsverdacht;
}

export interface Aufloeseergebnis {
  bearbeitet: number;
  gefunden: number;
  offen: number;
  stapel: number;
}

export async function ladeOrte(): Promise<Ortseintrag[]> {
  const { data } = await apiClient.get<Ortseintrag[]>('/orte');
  return data;
}

export async function ladeKartenOrte(): Promise<Kartenort[]> {
  const { data } = await apiClient.get<Kartenort[]>('/orte/karte');
  return data;
}

/**
 * Den nächsten Stapel offener Orte auflösen.
 *
 * Häppchenweise, weil der fremde Dienst nur eine Anfrage je Sekunde erlaubt:
 * Ein Durchlauf über 400 Orte dauerte sieben Minuten, und so lange hält keine
 * HTTP-Verbindung. Aufrufen, solange `offen` größer als null ist.
 */
export async function loeseOrteAuf(): Promise<Aufloeseergebnis> {
  const { data } = await apiClient.post<Aufloeseergebnis>('/orte/aufloesen');
  return data;
}

/** Einen Ort von Hand setzen. Ohne Koordinaten: „gehört auf keine Karte". */
export async function setzeOrt(
  schluessel: string,
  daten: { lat: number | null; lon: number | null; anzeigename: string | null },
): Promise<void> {
  await apiClient.put(`/orte/${encodeURIComponent(schluessel)}`, daten);
}

/** Die eigene Zuordnung zurücknehmen – danach gilt wieder das Wörterbuch. */
export async function loescheOrtszuordnung(schluessel: string): Promise<void> {
  await apiClient.delete(`/orte/${encodeURIComponent(schluessel)}`);
}
